import LazyLoad from "vanilla-lazyload";

import * as componentClasses from "./svelte-components.js";

import { hydrate } from "@propublica/pp-svelte/util/hydrate-baker.mjs";

// @ts-ignore (TODO(@alecglassford): Fix type problems with componentClasses)
hydrate(componentClasses);

new LazyLoad({
    elements_selector: "img.lazy",
    use_native: true,
});
new LazyLoad({
    elements_selector: "video.lazy",
});

// Add your code here! (or write other JS modules and use their imports here)

// Code for index.njk only (process.env.PATH_PREFIX gets replaced by `/` in dev
// and `/your-app-slug/` in prod). Doesn't matter for app root, but if checking
// other URLs, make sure to normalize the path to end in a slash (e.g. if
// the path is `/page-slug`, check `/page-slug/` instead).
// if (window.location.pathname === process.env.PATH_PREFIX) {
//     const selectElem = /** @type HTMLSelectElement */ (
//         document.querySelector("#data-sources")
//     );
//     selectElem.addEventListener("change", (ev) => {
//         if (selectElem.value) {
//             // Note the lack of starting slash in URL below: relative link ensures
//             // this always navigates correctly from index.njk, whether index.njk
//             // is at `localhost:3000/` or at `projects.propublica.org/app-slug/`
//             window.location.assign(`data-source/${selectElem.value}`);
//         }
//     });
// }
